import { Component } from "preact";
import style from "./style";

class Footer extends Component {
  render() {
    return (
      <div className={style.footerSectionWrapper}>
        <img src="/static/assets/images/home_logo.png" alt="United Nations" />
        <ul>
          <li>
            <a alt="United Nations" href="https://www.unrwa.org/">
              About us
            </a>
          </li>
          <li>
            <a
              alt="United Nations"
              href="https://www.un.org/sustainabledevelopment/sustainable-development-goals/"
            >
              Sustainable Development Goals
            </a>
          </li>
          <li>
            <a alt="United Nations" href="mailto:iati@unrwa.org">
              Contact us
            </a>
          </li>
        </ul>
        <p>
          Copyright © United Nations Relief and Works Agency for Palestine
          Refugees in the Near East
        </p>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./components/footer/index.js